/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'


// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

// Theme Configurations
import themeConfig from '../themeConfig.js'

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

// axios
import axios from 'axios'
Vue.prototype.$http = axios   /* export axios */
Vue.prototype.$api = axios.create({
  baseURL: themeConfig.apiurl
})

// Mixins
import mixins from './mixins';
Vue.mixin(mixins);

// ACL
import acl from './acl/acl'



// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
//import i18n from './i18n/i18n'


// Vuesax Admin Filters
import './filters/filters'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// i18n
import i18n from './i18n/i18n'


Vue.config.productionTip = false

/* export plugins/features */
new Vue({
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')

//Vuetify
//disabled 
/* import Vuetify from 'vuetify'
Vue.use(Vuetify) */
/* import 'vuetify/dist/vuetify.min.css' */